export enum TencerLanguage {
    SPANISH = 'es',
    ENGLISH = 'en',
}

export const LANGUAGE_STORAGE_KEY = 'lang';

export const DEFAULT_LANGUAGE = TencerLanguage.SPANISH;

export const SUPPORTED_LANGUAGES: TencerLanguage[] = [
    TencerLanguage.SPANISH,
    TencerLanguage.ENGLISH,
];

export const isSupportedLanguage = (value: string | null | undefined): value is TencerLanguage => {
    return !!value && SUPPORTED_LANGUAGES.includes(value as TencerLanguage);
};

export const getStoredLanguage = (): TencerLanguage | null => {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);

    return isSupportedLanguage(stored) ? stored : null;
};

export const storeLanguage = (language: TencerLanguage): void => {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
};

export const detectBrowserLanguage = (): TencerLanguage | null => {
    const candidates = window.navigator.languages && window.navigator.languages.length > 0
        ? Array.from(window.navigator.languages)
        : [window.navigator.language];

    const match = candidates
        .filter((candidate): boolean => !!candidate)
        .map((candidate): string => candidate.split('-')[0].toLowerCase())
        .find(isSupportedLanguage);

    return match ?? null;
};

export const resolveInitialLanguage = (): TencerLanguage => {
    return getStoredLanguage() ?? detectBrowserLanguage() ?? DEFAULT_LANGUAGE;
};
